// src/services/userService.js

import http from "./httpService";

class userService {
  async getProfile() {
    // const config = {
    //   headers: {
    //     Authorization: token,
    //   },
    // };
    return await http.get("/profile");
  }
  async updateProfile(data) {
    return await http.put("/profile", data);
  }
  async getProfileLessonPackages(token, page, limit, favorite) {
    const config = {
      headers: {
        Authorization: token,
      },
    };

    const url =
      favorite === true
        ? `/profile/liked_resources?page=${page}&limit=${limit}`
        : `/profile/lesson-packages?page=${page}&limit=${limit}`;

    const response = await http.get(url, config);

    if (response.data && response.data.data && response.data.data.rows) {
      response.data.data.rows.forEach((element) => {
        if (element.type === "lesson_package") {
          this.setThumbnails(element.resourceData);
        } else if (element.type === "makercart") {
          console.log("element", element);
        } else {
          this.setThumbnails(element);
        }
      });
    }

    return response;
  }

  async getLikedResources() {
    return await http.get(`/stem-studio/makercart/liked`);
  }

  async likeLessonPackage(token, lessonPackageId) {
    const config = {
      headers: {
        Authorization: token,
      },
    };
    const url = `/lesson-packages/like/${lessonPackageId}`;
    return await http.put(url, {}, config); // Menggunakan PUT request dengan body kosong
  }

  setThumbnails(element) {
    const validSubjects = ["ela", "math", "science", "socialstudies"];
    let subjectKey = element.subject.toLowerCase().replace(/\s/g, "");

    if (!validSubjects.includes(subjectKey)) {
      element.thumbnail = null;
    } else {
      switch (element.domain.toLowerCase()) {
        case "programming & coding":
          element.thumbnail = `/images/thumbnail/programming-${subjectKey}.png`;
          break;
        case "extended reality (ar/vr/mr)":
          element.thumbnail = `/images/thumbnail/ar-${subjectKey}.png`;
          break;
        case "multimedia and animation":
          element.thumbnail = `/images/thumbnail/multimedia-${subjectKey}.png`;
          break;
        case "design & simulation":
          element.thumbnail = `/images/thumbnail/design-${subjectKey}.png`;
          break;
        case "app development":
          element.thumbnail = `/images/thumbnail/app-dev-${subjectKey}.png`;
          break;
        case "artificial intelligence":
          element.thumbnail = `/images/thumbnail/ai-${subjectKey}.png`;
          break;
        default:
          element.thumbnail = null;
      }
    }
  }

  async getAllUser(name, userIds = [], ymc = true) {
    if (userIds.length > 0) {
      const userIdsParam = userIds.join(",");
      return await http.get(
        `/users?search=${name}&limit=60&user_ids=${userIdsParam}&ymc=true`
      );
    } else {
      return await http.get(
        `/users?search=${name}&limit=60${ymc ? "&ymc=true" : ""}`
      );
    }
  }

  async setPrimaryEmail(accountId) {
    return await http.put(`/profile/set-primary/${accountId}`);
  }

  async disconnectAccount(accountId) {
    return await http.delete(`/profile/disconnect-accounts/${accountId}`);
  }

  async connectGoogle() {
    return await http.get("/profile/connect-google");
  }

  async connectEmail(data) {
    return await http.post("/profile/add-sso-password", data);
  }

  async requestConnectRegulerEmail(email) {
    return await http.post("/profile/connect-reguler/request", { email });
  }

  async verifyConnectRegulerEmail(email, otp) {
    return await http.post("/profile/connect-reguler/verify-otp", {
      email,
      otp,
    });
  }

  async connectOtpRegulerEmail(data) {
    return await http.post("/profile/connect-reguler/otp", data);
  }

  async connectRegulerEmail(data) {
    return await http.post("/profile/connect-reguler", data);
  }

  async disconnectEmail(data) {
    return await http.delete("/profile/disconnect-reguler", { data });
  }

  async disconnectGoogle(data) {
    return await http.delete("/profile/disconnect-google", { data });
  }
}

export default new userService();
